import { useSelector } from "react-redux";
import { getEdgeClass } from "../../utils";

const SealOfQualityBadge = ({ sealOfQualityLabel, fullWidth }) => {
  const { edge = false } = useSelector((state) => state?.uiConfig) || {};
  return (
    <>
      {sealOfQualityLabel && sealOfQualityLabel !== "None" && (
        <span
          className={`px-4  ${getEdgeClass(edge, "rounded-2xl")} flex items-center justify-center border text-[0.75rem] uppercase text-[#999898] border-[#999898] px-2 py-[3px] h-auto whitespace-nowrap ${fullWidth ? "w-full" : ""}`}
        >
          {sealOfQualityLabel}
        </span>
      )}
    </>
  );
};
export default SealOfQualityBadge;
